export const cases = [
  {
    id: 1,
    sector: 'Indústria',
    subtitle: 'Cresceram na produção e precisavam de clareza nos números.',
    items: [
      {
        id: 'ind-1',
        name: 'Pablo',
        company: 'Ondupel · Indústria',
        image: 'cases-assets/fotos/pablo.jpg',
        rating: 5,
        quote: 'A Prana nos ajudou a organizar nossos indicadores de forma muito atuante e próxima. Profissionais de alto padrão, com espírito colaborativo."',
      },
      {
        id: 'ind-2',
        name: 'Gabriela Taylor',
        company: 'Indústria de Cosméticos',
        image: 'cases-assets/fotos/gabriela-taylor.jpg',
        rating: 5,
        quote: 'A melhor escolha que fizemos em prol da saúde financeira do negócio! Todos os consultores são muito atenciosos e não economizam em conhecimento."',
      },
      {
        id: 'ind-3',
        name: 'Vítor Moreira',
        company: 'Lavanderia · Indústria',
        image: 'cases-assets/fotos/vitor.jpg',
        rating: 5,
        quote: 'Quando consegui interpretar a DRE junto com a Prana, comecei a ver horizontes e oportunidades que eu não conseguia ver sozinho."',
      },
    ],
  },
  {
    id: 2,
    sector: 'Saúde',
    subtitle: 'Clínicas que aprenderam a enxergar o negócio, não só o atendimento.',
    items: [
      {
        id: 'saude-1',
        name: 'Bruna',
        company: 'Dentista e Empresária',
        image: 'cases-assets/fotos/bruna.jpg',
        rating: 5,
        quote: 'A Prana me ensinou a ser empresária. Até hoje não sei como sobrevivemos tanto tempo sem ela."',
      },
      {
        id: 'saude-2',
        name: 'Dra. Raissa Pinheiro',
        company: 'Dentista e Empresária',
        image: 'cases-assets/fotos/raissa.jpg',
        rating: 5,
        quote: 'O acompanhamento vai além dos números — contribui também no crescimento em equipe e profissional. Recomendo a todos que querem crescer com segurança."',
      },
    ],
  },
  {
    id: 3,
    sector: 'Alimentação',
    subtitle: 'Restaurantes, cafeterias e padarias que passaram a saber quanto realmente sobra.',
    items: [
      {
        id: 'alim-1',
        name: 'Vinícius Paiva',
        company: 'Restaurante Estação',
        image: 'cases-assets/fotos/vinicius.jpg',
        rating: 5,
        quote: 'A Prana vem nos capacitando a ter maior consciência dos números do nosso restaurante, trazendo visão empresarial que antes não tínhamos. Mais tranquilidade e segurança para decidir."',
      },
      {
        id: 'alim-2',
        name: 'Luiza',
        company: 'Acallento · Cafeteria',
        image: 'cases-assets/fotos/luiza.jpg',
        rating: 5,
        quote: 'Hoje temos total domínio sobre o negócio. Saímos do operacional, treinamos líderes e criamos protocolos padronizados. Recomendo sem hesitar."',
      },
    ],
  },
  {
    id: 4,
    sector: 'Serviços e Educação',
    subtitle: 'Negócios de serviço que trocaram o achismo pela decisão com dados.',
    items: [
      {
        id: 'serv-1',
        name: 'Gerência YES! JF',
        company: 'Curso de Inglês',
        image: 'cases-assets/fotos/gerencia-yes.jpg',
        rating: 5,
        quote: 'Nos deu clareza para enxergarmos o financeiro e nos ajudou a conseguir tomar decisões."',
      },
      {
        id: 'serv-2',
        name: 'Carol Medeiros',
        company: 'Estética',
        image: 'cases-assets/fotos/carol.jpg',
        rating: 5,
        quote: 'Eu me perdia na precificação e no fechamento do mês. Eles me deram uma estrutura fora do normal."',
      },
    ],
  },
];
